export default function Footer() {
  const footerLinks = [
    {
      title: '热门专题',
      items: ['明星恋情', '综艺翻车', '影视剧透', '时尚红毯', '音乐现场'],
    },
    {
      title: '关于我们',
      items: ['平台介绍', '投稿爆料', '联系我们', '隐私政策', '用户协议'],
    },
    {
      title: '关注我们',
      items: ['微博', '微信公众号', '抖音', '小红书', 'B站'],
    },
  ];

  return (
    <footer id="footer" className="bg-background-900 text-white">
      <div className="w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
            <div className="sm:col-span-2 lg:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-fire-fill text-white"></i>
                </div>
                <span className="font-heading font-bold text-lg">吃瓜网每日大赛</span>
              </div>
              <p className="text-foreground-400 text-sm leading-relaxed mb-6">
                吃瓜网每日大赛💥每日推送最火最新吃瓜爆料，🎭今日吃瓜明星大瓜第一时间曝光，
                汇聚娱乐圈黑料、八卦最新消息，全网内幕一网打尽，持续追踪热点事件。
              </p>
              <div className="flex items-center gap-3">
                {['weibo', 'wechat', 'tiktok', 'bilibili'].map((icon) => (
                  <div
                    key={icon}
                    className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-600 transition-colors cursor-pointer"
                  >
                    <i className={`ri-${icon}-line text-white/80 text-sm`}></i>
                  </div>
                ))}
              </div>
            </div>

            {footerLinks.map((col) => (
              <div key={col.title}>
                <h3 className="font-heading font-bold text-sm mb-4 text-white/90">
                  {col.title}
                </h3>
                <ul className="space-y-2.5">
                  {col.items.map((item) => (
                    <li key={item}>
                      <a
                        href="#"
                        onClick={(e) => e.preventDefault()}
                        className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer"
                      >
                        {item}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-background-800">
            <div className="mb-6">
              <h4 className="font-heading font-bold text-xs text-foreground-500 mb-3">合作伙伴</h4>
              <div className="flex flex-wrap items-center gap-4">
                <span className="text-foreground-600 text-xs">虚位以待</span>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-foreground-500 text-xs">
                &copy; {new Date().getFullYear()} 吃瓜网每日大赛 - 娱乐八卦爆料平台。本站内容仅供娱乐参考，不构成任何建议。
              </p>
              <div className="flex items-center gap-4">
                <a href="#" onClick={(e) => e.preventDefault()} className="text-foreground-500 hover:text-foreground-300 text-xs cursor-pointer">隐私政策</a>
                <a href="#" onClick={(e) => e.preventDefault()} className="text-foreground-500 hover:text-foreground-300 text-xs cursor-pointer">用户协议</a>
                <a href="#" onClick={(e) => e.preventDefault()} className="text-foreground-500 hover:text-foreground-300 text-xs cursor-pointer">免责声明</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}